import { useState } from "react";
import { useCollege } from "../context/CollegeContext";
import { FaCloudUploadAlt, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const restrictedFileTypes = [".exe", ".bat", ".sh", ".apk", ".doc", ".docx"]; // 🚫 Restricted file types (PPT/PPTX allowed)

const FileUpload = () => {
  const { selectedCollege, uploadedFiles, setUploadedFiles } = useCollege();
  const navigate = useNavigate();
  const [fileError, setFileError] = useState("");

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    handleFiles(files);
  };

  const handleFiles = (files) => {
    const validFiles = [];
    const invalidFiles = [];

    files.forEach((file) => {
      const fileName = file.name.toLowerCase();

      if (restrictedFileTypes.some((ext) => fileName.endsWith(ext))) {
        invalidFiles.push(file.name);
      } else {
        validFiles.push(file);
      }
    });

    if (invalidFiles.length > 0) {
      setFileError(`The following files are not allowed: ${invalidFiles.join(", ")}`);
      toast.error("Unsupported file types detected.");
    } else {
      setFileError("");
      setUploadedFiles([...uploadedFiles, ...validFiles]);
    }
  };

  const handleRemoveFile = (index) => {
    const updatedFiles = uploadedFiles.filter((_, i) => i !== index);
    setUploadedFiles(updatedFiles);
  };

  const handleNext = () => {
    if (uploadedFiles.length > 0) {
      navigate("/customize");
    } else {
      toast.error("Please upload at least one file.");
    }
  };

  return (
    <div className="mt-6 p-6 w-full max-w-lg rounded-lg shadow-lg transition-all bg-white dark:bg-gray-800 text-center">
      <h2 className="text-2xl font-bold mb-2 text-indigo-500">{selectedCollege} File Upload</h2>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
        Your files will be <strong>deleted after printing</strong> for privacy.
      </p>

      {/* File Upload */}
      <label className="cursor-pointer flex flex-col items-center justify-center p-5 border-2 border-dashed rounded-lg transition-all dark:border-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700">
        <FaCloudUploadAlt className="text-4xl text-indigo-500 mb-2" />
        <span className="text-sm font-medium text-gray-800 dark:text-gray-200">
          Click to upload files
        </span>
        <input type="file" className="hidden" multiple onChange={handleFileChange} />
      </label>

      {/* Show File Error Message */}
      {fileError && <p className="mt-3 text-sm text-red-500 font-medium">{fileError}</p>}

      {/* Display Uploaded Files */}
      {uploadedFiles.length > 0 && (
        <div className="mt-4">
          <h3 className="text-lg font-semibold mb-2 text-indigo-500">Uploaded Files:</h3>
          <ul className="space-y-2">
            {uploadedFiles.map((file, index) => (
              <li
                key={index}
                className="flex items-center justify-between p-2 bg-gray-100 dark:bg-gray-700 rounded-lg"
              >
                <span className="text-sm text-gray-800 dark:text-gray-200">{file.name}</span>
                <button
                  onClick={() => handleRemoveFile(index)}
                  className="text-red-500 hover:text-red-600"
                >
                  <FaTimes />
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Continue Button */}
      <button
        onClick={handleNext}
        className="mt-4 px-5 py-2 rounded-lg text-white font-medium bg-indigo-500 hover:bg-indigo-600 transition-all"
      >
        Continue
      </button>
    </div>
  );
};

export default FileUpload;
